module.exports = __webpack_public_path__ + "static/media/earthlovelife_logo_big.0b886db9.png";